import React from 'react';
import { AnalysisRecord } from '@/lib/db/analysis';
import { formatDate } from '@/lib/utils/date';
import { ExternalLink } from 'lucide-react';

interface AnalysisHistoryItemProps {
  analysis: AnalysisRecord;
}

export function AnalysisHistoryItem({ analysis }: AnalysisHistoryItemProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 hover:border-gray-300 transition-colors">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="font-medium mb-1">{analysis.url}</h3>
          <p className="text-sm text-gray-500">
            Analyzed on {formatDate(analysis.createdAt)}
          </p>
        </div>
        <a
          href={analysis.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-gray-600"
        >
          <ExternalLink className="w-5 h-5" />
        </a>
      </div>
      
      <div className="space-y-2">
        <p className="text-sm text-gray-600">
          Found {analysis.issues.length} issues to improve
        </p>
        <div className="flex flex-wrap gap-2">
          {analysis.issues.slice(0, 3).map((issue) => (
            <span
              key={issue.id}
              className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full"
            >
              {issue.category}
            </span>
          ))}
          {analysis.issues.length > 3 && (
            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
              +{analysis.issues.length - 3} more
            </span>
          )}
        </div>
      </div>
    </div>
  );
}